import { Checkbox, CheckboxProps } from 'antd';
import {
  PrivacyPolicyLink,
  ServiceAgreementLink,
  // SoftWareLicenseLink,
} from 'components/AgreementsDocuments';
import { isQuickChat } from 'productLine';
import TransComponent from '../components/TransComponent';
import { T } from '@tolgee/react';

export interface AgreementsCheckboxProps extends CheckboxProps {}

const AgreementsCheckbox = (props: AgreementsCheckboxProps) => {
  return (
    <Checkbox {...props}>
      <T
        keyName={
          isQuickChat
            ? 'quickchat_registry_agree_accept'
            : 'ViewStartups.registry.info.form.agreement.label'
        }
        params={{
          x: <TransComponent content={<ServiceAgreementLink />} />,
          y: <TransComponent content={<PrivacyPolicyLink />} />,
        }}
      />
    </Checkbox>
  );
};
export default AgreementsCheckbox;
